import { SCROLL_RESET, SCROLL_RESTORATION } from '../constants/scroll'

export function resetWindowScroll(): void {
  const root = document.documentElement
  const previous = root.style.scrollBehavior
  root.style.scrollBehavior = 'auto'
  window.scrollTo(SCROLL_RESET)
  root.style.scrollBehavior = previous
}

export function disableBrowserScrollRestoration(): void {
  if (!('scrollRestoration' in window.history)) return
  window.history.scrollRestoration = SCROLL_RESTORATION
}
